import React, { useState, useEffect } from "react";
import Table from "react-bootstrap/Table";
import Button from "react-bootstrap/Button";
import Footer from "./Footer";
import Header from "./Header";
import Scroll from "./Scroll";
import { Form } from "react-bootstrap";
import Col from "react-bootstrap/Col";
import Row from "react-bootstrap/Row";
import Card from "react-bootstrap/Card";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import Spinner from "react-bootstrap/Spinner";
import { Link } from "react-router-dom";
import CrackersLoader from "./CrackersLoader";
import { FaTrashAlt, FaShoppingCart, FaUser, FaPhone, FaEnvelope, FaMapMarkerAlt, FaCity, FaTag, FaRupeeSign, FaCheck, FaWhatsapp, FaUniversity, FaQrcode } from "react-icons/fa";
import MobileNavigation from "./MobileNavigation";
import PaymentModal from "./PaymentModal";
import "./cart.css";

// Helper function to round to nearest whole number
const roundToNearestRupee = (amount) => {
  return Math.round(amount);
};

function Cart() {
  const [cartItems, setCartItems] = useState([]);
  const [discountvalue, setDiscountvalue] = useState();
  const [formData, setFormData] = useState({
    firstName: "",
    mobileNumber: "",
    email: "",
    address: "",
    city: "",
    state: "",
    pincode: "",
    chitCode: "",
  });
  const [stateType, setStateType] = useState("");
  const [formErrors, setFormErrors] = useState({});
  const [loading, setLoading] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [minimumOrderTn, setMinimumOrderTn] = useState(null);
  const [minimumOrderOther, setMinimumOrderOther] = useState(null);
  const [storeClosed, setStoreClosed] = useState(null);
  const [packingPercentageTn, setPackingPercentageTn] = useState(0);
  const [packingPercentageOther, setPackingPercentageOther] = useState(0);
  const navigate = useNavigate();
  const [isSmallScreen, setIsSmallScreen] = useState(window.innerWidth <= 426);

  const [couponCode, setCouponCode] = useState("");
  const [isCouponApplied, setIsCouponApplied] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [coupondiscount, setCouponDiscount] = useState(0);
  const [validCoupons, setValidCoupons] = useState([]);

  // Payment states
  const [paymentMethod, setPaymentMethod] = useState('bank');
  const [showPaymentModal, setShowPaymentModal] = useState(false);
  const [bankDetails, setBankDetails] = useState({
    account_no: '',
    ifsc_code: '',
    account_name: '',
    branch_name: '',
    bank_details: ''
  });
  const [upiQRCode, setUpiQRCode] = useState('');

  // API URLs
  const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
  const API_ADMIN_BASE_URL = process.env.REACT_APP_ADMIN_API_BASE_URL;

  // Check if state is selected
  const isStateSelected = () => {
    return formData.state?.trim() !== '';
  };

  // Get minimum order amount based on state
  const getMinimumOrderAmount = () => {
    const stateLower = formData.state?.trim().toLowerCase() || '';
    const isTamilNadu = stateLower === "tamil nadu" || stateLower === "tamilnadu";

    if (isTamilNadu) {
      return minimumOrderTn;
    } else if (stateLower === "") {
      return Math.min(minimumOrderTn || Infinity, minimumOrderOther || Infinity);
    } else {
      return minimumOrderOther;
    }
  };

  // Get packing percentage based on state
  const getPackingPercentage = () => {
    if (!isStateSelected()) {
      return 0;
    }
    const stateLower = formData.state?.trim().toLowerCase() || '';
    const isTamilNadu = stateLower === "tamil nadu" || stateLower === "tamilnadu";
    return isTamilNadu ? packingPercentageTn : packingPercentageOther;
  };

  // Calculate packing amount
  const getPackingAmount = () => {
    const packingPercent = getPackingPercentage();
    const orderTotal = getOrderTotal();
    return (orderTotal * packingPercent) / 100;
  };

  useEffect(() => {
    const handleResize = () => {
      setIsSmallScreen(window.innerWidth <= 426);
    };

    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  useEffect(() => {
    const items = JSON.parse(localStorage.getItem("cartItems")) || [];
    setCartItems(items);
  }, []);

  const handleQuantityChange = (product_id, change) => {
    const updatedItems = cartItems.map((item) => {
      if (item.product_id === product_id) {
        const newCount = item.count + change;
        if (newCount < 1) {
          return { ...item, count: 1 };
        }
        return { ...item, count: newCount };
      }
      return item;
    });

    setCartItems(updatedItems);
    localStorage.setItem("cartItems", JSON.stringify(updatedItems));

    const updatedCounts = updatedItems.reduce((acc, item) => {
      acc[item.product_id] = item.count;
      return acc;
    }, {});

    saveCountsToLocalStorage(updatedCounts);
  };

  const handleDelete = (product_id) => {
    const updatedItems = cartItems.filter(
      (item) => item.product_id !== product_id
    );

    localStorage.setItem("cartItems", JSON.stringify(updatedItems));
    setCartItems(updatedItems);
    localStorage.removeItem(`count_${product_id}`);

    const totalUniqueProductCount = updatedItems.length;
    localStorage.setItem("cartCount", totalUniqueProductCount);
    saveCountsToLocalStorage(updatedItems);
  };

  const calculateTotal = (price, count) => {
    if (!price) {
      return "0";
    }
    const sanitizedPrice = parseFloat(price.replace(/[^\d.-]/g, ""));
    if (isNaN(sanitizedPrice)) {
      return "0";
    }
    return roundToNearestRupee(count * sanitizedPrice);
  };

  const getSubtotal = () => {
    return roundToNearestRupee(
      cartItems.reduce((total, item) => {
        return total + parseFloat(calculateTotal(item.oldprice, item.count));
      }, 0)
    );
  };

  const getDiscountedTotal = () => {
    const discountAmount = cartItems.reduce((total, item) => {
      if (item.is_non_discount === "0") {
        const discount = Math.round(discountvalue);
        const itemTotal = parseFloat(calculateTotal(item.oldprice, item.count));
        const discountedItemTotal = (itemTotal * discount) / 100;
        return total + discountedItemTotal;
      } else {
        return total;
      }
    }, 0);

    return roundToNearestRupee(discountAmount);
  };

  const getOrderTotal = () => {
    const subtotal = getSubtotal();
    const discountTotal = getDiscountedTotal();
    return roundToNearestRupee(subtotal - discountTotal);
  };

  const coupondiscountamount = () => {
    const total = getOrderTotal();
    return roundToNearestRupee(total * (coupondiscount / 100));
  };

  const grandTotal = () => {
    let total = getOrderTotal();

    if (isCouponApplied && coupondiscount > 0) {
      total = total - coupondiscountamount();
    }

    if (isStateSelected()) {
      const packingAmount = getPackingAmount();
      total = total + packingAmount;
    }

    return roundToNearestRupee(total);
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    if (name === "mobileNumber" && !/^\d*$/.test(value)) {
      return;
    }
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const handleStateTypeChange = (e) => {
    const value = e.target.value;
    setStateType(value);
    if (value === "tamilnadu") {
      setFormData({
        ...formData,
        state: "Tamil Nadu",
      });
    } else if (value === "other") {
      setFormData({
        ...formData,
        state: "",
      });
    } else {
      setFormData({
        ...formData,
        state: "",
      });
    }
  };

  const handleOtherStateChange = (e) => {
    setFormData({
      ...formData,
      state: e.target.value,
    });
  };

  const validateForm = () => {
    const errors = {};
    Object.keys(formData).forEach((key) => {
      if (key !== "email" && key !== "chitCode" && !formData[key]) {
        errors[key] = "This field is required.";
      }
    });

    setFormErrors(errors);
    return Object.keys(errors).length === 0;
  };

  const handleOrderSuccess = (orderId) => {
    localStorage.removeItem("cartItems");
    localStorage.removeItem("cartCount");
    const productKeys = Object.keys(localStorage).filter((key) =>
      key.startsWith("count_")
    );
    productKeys.forEach((key) => localStorage.removeItem(key));
    window.dispatchEvent(new Event("cartUpdated"));

    if (orderId) {
      navigate(`/thanks?order_id=${orderId}`);
    } else {
      navigate("/thanks");
    }
  };

  useEffect(() => {
    const loadAllData = async () => {
      try {
        const homeRes = await axios.post(`${API_BASE_URL}home.php`);
        const { body } = homeRes.data;

        if (body) {
          const storeInfo = body.minimum_order_store_closed?.[0];
          if (storeInfo) {
            setMinimumOrderTn(storeInfo.minimum_order);
            setMinimumOrderOther(storeInfo.other_state_minimum_order);
            setStoreClosed(storeInfo.store_closed);
            setPackingPercentageTn(parseFloat(storeInfo.packing_percentage_tn) || 0);
            setPackingPercentageOther(parseFloat(storeInfo.packing_percentage_other) || 0);
          }

          if (typeof body.coupen_code === "string") {
            setValidCoupons(body.coupen_code.split(',').map(code => code.trim().toUpperCase()));
          } else if (Array.isArray(body.coupen_code) && typeof body.coupen_code[0] === "string") {
            setValidCoupons(body.coupen_code[0].split(',').map(code => code.trim().toUpperCase()));
          }

          setDiscountvalue(body.discount_value?.[0]?.discount_value || 0);
          setCouponDiscount(body.coupen_percentage || 0);
        }

        const settingRes = await axios.post(`${API_ADMIN_BASE_URL}setting_detail.php`);
        if (settingRes.data.head.code === 200) {
          const settings = settingRes.data.body;
          setBankDetails({
            account_no: settings.account_no || '',
            ifsc_code: settings.ifsc_code || '',
            account_name: settings.account_name || '',
            branch_name: settings.branch_name || '',
            bank_details: settings.bank_details || ''
          });
          setUpiQRCode(settings.upi_qr_code || '');
        }

      } catch (error) {
        console.error("Error loading data:", error);
      } finally {
        setIsLoading(false);
      }
    };

    loadAllData();
  }, [API_BASE_URL, API_ADMIN_BASE_URL]);

  const handleCouponChange = (e) => {
    setCouponCode(e.target.value.trim().toUpperCase());
    setErrorMessage("");
    setIsCouponApplied(false);
  };

  const applyCoupon = () => {
    if (!couponCode) {
      setErrorMessage("Please enter a referral code.");
      setIsCouponApplied(false);
      return;
    }

    if (validCoupons.includes(couponCode.toUpperCase())) {
      setIsCouponApplied(true);
      setErrorMessage("");
      // Show success message
      alert(`Coupon code "${couponCode}" applied successfully! You get ${coupondiscount}% discount.`);
    } else {
      setErrorMessage("Invalid referral code. Please enter a valid one.");
      setIsCouponApplied(false);
    }
  };

  const handlePaymentProceed = async (screenshot) => {
    setLoading(true);
    setShowPaymentModal(false);

    try {
      const packingPercent = getPackingPercentage();
      const packingAmount = getPackingAmount();
      const orderTotal = getOrderTotal();
      const couponDiscountAmount = isCouponApplied ? coupondiscountamount() : 0;
      const finalTotal = orderTotal + packingAmount - couponDiscountAmount;

      const orderData = {
  name: formData.firstName,
  email: formData.email,
  phonenumber: formData.mobileNumber,
  address: formData.address,
  city: formData.city,
  state: formData.state,
  pincode: formData.pincode,
  chit_code: formData.chitCode,
  
  subtotal: orderTotal,
  discount: getDiscountedTotal(),
  discount_percentage: Math.round(discountvalue),
  packing_percentage: packingPercent,
  packing_charge: packingAmount,
  coupon_discount: couponDiscountAmount,
  total: roundToNearestRupee(finalTotal),
  coupen_code: isCouponApplied ? couponCode : "",
  payment_method: paymentMethod,
  payment_screenshot: screenshot || '',

  product: cartItems.map((item) => {
    const isNonDiscount = parseInt(item.is_non_discount, 10) === 1;

    // Non-discount product → oldprice
    // Discount product → price
    const checkedPrice = isNonDiscount
      ? item.oldprice
      : item.price;

    const unitPrice =
      parseFloat(checkedPrice?.replace(/[^\d.-]/g, "")) || 0;

    return {
      product_id: item.product_id,
      category_id: item.category_id || "",
      product_name: item.product_name,
      unit_price: unitPrice,
      quantity: item.count,
      final_price: roundToNearestRupee(unitPrice * item.count),
    };
  }),
};


      console.log("Order Data:", orderData);

      const response = await axios.post(`${API_BASE_URL}order.php`, orderData);
      console.log("API Response:", response.data);

      let orderId = null;
      if (response.data && response.data.body && response.data.body.order_id) {
        orderId = response.data.body.order_id;
      }

      alert("Order placed successfully!");
      handleOrderSuccess(orderId);
    } catch (error) {
      console.error("There was an error placing the order!", error);
      alert("Failed to place order. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    if (validateForm()) {
      if (!paymentMethod) {
        alert('Please select a payment method');
        return;
      }

      if (!isStateSelected()) {
        alert('Please select your state');
        return;
      }

      const stateLower = formData.state?.trim().toLowerCase() || '';
      const isTamilNadu = stateLower === "tamil nadu" || stateLower === "tamilnadu";
      const minOrder = isTamilNadu ? minimumOrderTn : minimumOrderOther;
      const grandTotalAmount = grandTotal();

      if (grandTotalAmount < minOrder) {
        alert(`Minimum order amount for ${isTamilNadu ? 'Tamil Nadu' : 'your state'} is ₹${minOrder}. Your current total is ₹${grandTotalAmount}.`);
        return;
      }

      setShowPaymentModal(true);
    }
  };

  const saveCountsToLocalStorage = (data) => {
    if (Array.isArray(data)) {
      data.forEach((item) => {
        localStorage.setItem(`count_${item.product_id}`, item.count);
      });
    } else {
      Object.entries(data).forEach(([product_id, count]) => {
        localStorage.setItem(`count_${product_id}`, count);
      });
    }
    window.dispatchEvent(new Event("storage"));
  };

  if (isLoading) {
    return <CrackersLoader />;
  }

  const packingPercent = getPackingPercentage();
  const packingAmount = getPackingAmount();
  const orderTotal = getOrderTotal();
  const stateSelected = isStateSelected();
  const stateLower = formData.state?.trim().toLowerCase() || '';
  const isTamilNaduSelected = stateLower === "tamil nadu" || stateLower === "tamilnadu";
  const grandTotalAmount = grandTotal();

  // Check if packing charge should be shown (percentage > 0 AND amount > 0)
  const showPackingCharge = stateSelected && packingPercent > 0 && packingAmount > 0;

  const getMinimumOrderMessage = () => {
    if (!minimumOrderTn && !minimumOrderOther) return null;

    if (!stateSelected) {
      return `⚠️ Please select your state. Minimum order: Tamil Nadu ₹${minimumOrderTn || 0} | Other States ₹${minimumOrderOther || 0}`;
    }

    if (isTamilNaduSelected) {
      if (grandTotalAmount < minimumOrderTn) {
        return `⚠️ Minimum order amount for Tamil Nadu is ₹${minimumOrderTn}. Add ₹${(minimumOrderTn - grandTotalAmount).toFixed(2)} more to proceed.`;
      } else {
        return `✅ Your order meets the minimum order requirement of ₹${minimumOrderTn} for Tamil Nadu.`;
      }
    }

    if (grandTotalAmount < minimumOrderOther) {
      return `⚠️ Minimum order amount for your state is ₹${minimumOrderOther}. Add ₹${(minimumOrderOther - grandTotalAmount).toFixed(2)} more to proceed.`;
    } else {
      return `✅ Your order meets the minimum order requirement of ₹${minimumOrderOther} for your state.`;
    }
  };

  const minimumOrderMessage = getMinimumOrderMessage();
  const isMinimumMet = stateSelected && grandTotalAmount >= (isTamilNaduSelected ? minimumOrderTn : minimumOrderOther);

  return (
    <div className="mathi-cart-page">
      <Header />

      {/* Cart Header */}
      <div className="cart-header-section">
        <div className="cart-content-wrapper">
          <div className="cart-header-content text-center py-4">
            <FaShoppingCart className="cart-header-icon" />
            <h1 className="cart-title">Your Shopping Cart</h1>
            <p className="cart-subtitle">
              Review your items and proceed to checkout
            </p>
            <div className="cart-items-count">
              <span className="badge bg-primary">{cartItems.length} items</span>
            </div>
          </div>
        </div>
      </div>

      <div className="cart-content-wrapper">
        {/* Cart Items Table */}
        <div className="cart-table-section mb-4">
          <div className="table-responsive">
            <Table className="">
              <thead className="cart-table-head" style={{ "--bs-table-bg": "linear-gradient(135deg, #9622d9, #b31b80)" }}>
                <tr className="cart-table-head" style={{ background: 'linear-gradient(135deg, #9622d9, #b31b80)' }}>
                  <th className="text-center color-white">Image</th>
                  <th className="text-center color-white">Product Name</th>
                  {!isSmallScreen && <th className="text-center color-white">Price</th>}
                  {!isSmallScreen && <th className="text-center color-white">Quantity</th>}
                  <th className="text-center color-white">Total</th>
                  <th className="text-center color-white">Del</th>
                </tr>
              </thead>
              <tbody>
                {cartItems.length === 0 ? (
                  <tr>
                    <td colSpan={isSmallScreen ? 4 : 6} className="text-center py-5">
                      <div className="empty-cart">
                        <FaShoppingCart className="empty-cart-icon" />
                        <h5>Your cart is empty</h5>
                        <p>Add some crackers to get started!</p>
                        <Link to="/" className="btn btn-primary">
                          Continue Shopping
                        </Link>
                      </div>
                    </td>
                  </tr>
                ) : (
                  cartItems.map((item) => {
                    const isNonDiscount = parseInt(item.is_non_discount, 10) === 1;
                    const roundedOldPrice = item.oldprice ? roundToNearestRupee(parseFloat(item.oldprice.replace(/[^\d.-]/g, ""))) : 0;
                    const roundedPrice = item.price ? roundToNearestRupee(parseFloat(item.price.replace(/[^\d.-]/g, ""))) : 0;

                    return (
                      <tr key={item.product_id} className="cart-item-row">
                        <td className="cart-item-image">
                          <img
                            src={item.image}
                            alt={item.product_name}
                            loading="lazy"
                            className="img-thumbnail"
                          />
                        </td>
                        <td className="cart-item-details">
                          <h6 className="cart-item-name">{item.product_name}</h6>
                          {isSmallScreen && (
                            <div className="mobile-price-qty">
                              <div className="mobile-price">
                                {isNonDiscount ? (
                                  <span className="current-price">
                                    <i className="bi bi-currency-rupee"></i> {roundedOldPrice}
                                  </span>
                                ) : (
                                  <>
                                    <del className="old-price">
                                      <i className="bi bi-currency-rupee"></i> {roundedOldPrice}
                                    </del>
                                    <span className="current-price">
                                      <i className="bi bi-currency-rupee"></i> {roundedPrice}
                                    </span>
                                  </>
                                )}
                              </div>
                              <div className="mobile-quantity">
                                <Button
                                  variant="outline-secondary"
                                  size="sm"
                                  onClick={() => handleQuantityChange(item.product_id, -1)}
                                >
                                  -
                                </Button>
                                <span className="quantity-display">{item.count}</span>
                                <Button
                                  variant="outline-secondary"
                                  size="sm"
                                  onClick={() => handleQuantityChange(item.product_id, 1)}
                                >
                                  +
                                </Button>
                              </div>
                            </div>
                          )}
                        </td>
                        {!isSmallScreen && (
                          <td className="cart-item-price text-center">
                            {isNonDiscount ? (
                              <span className="current-price">
                                <i className="bi bi-currency-rupee"></i> {roundedOldPrice}
                              </span>
                            ) : (
                              <>
                                <del className="old-price">
                                  <i className="bi bi-currency-rupee"></i> {roundedOldPrice}
                                </del>
                                <br />
                                <span className="current-price">
                                  <i className="bi bi-currency-rupee"></i> {roundedPrice}
                                </span>
                              </>
                            )}
                          </td>
                        )}
                        {!isSmallScreen && (
                          <td className="cart-item-quantity">
                            <div className="quantity-control">
                              <Button
                                variant="outline-secondary"
                                size="sm"
                                onClick={() => handleQuantityChange(item.product_id, -1)}
                              >
                                -
                              </Button>
                              <span className="quantity-number">{item.count}</span>
                              <Button
                                variant="outline-secondary"
                                size="sm"
                                onClick={() => handleQuantityChange(item.product_id, 1)}
                              >
                                +
                              </Button>
                            </div>
                          </td>
                        )}
                        <td className="cart-item-total text-center">
                          <span className="item-total">
                            <i className="bi bi-currency-rupee"></i>
                            {calculateTotal(
                              isNonDiscount ? item.oldprice : item.price,
                              item.count
                            )}
                          </span>
                        </td>
                        <td className="cart-item-action text-center">
                          <Button
                            variant="outline-danger"
                            size="sm"
                            onClick={() => handleDelete(item.product_id)}
                            title="Remove item"
                            className="delete-button"
                          >
                            <FaTrashAlt />
                          </Button>
                        </td>
                      </tr>
                    );
                  })
                )}
              </tbody>
            </Table>
          </div>
        </div>

        {/* Cart Summary and Checkout */}
        <div className="row">
          <div className="col-lg-8">
            <Card className="cart-form-card shadow-sm">
              <Card.Body>
                <div className="form-header mb-4">
                  <div className="form-icon">
                    <FaUser />
                  </div>
                  <h4>Customer Details</h4>
                  <p className="text-muted">Fill in your information to proceed</p>
                </div>

                <Form noValidate>
                  <Row className="g-3">
                    <Col md={6}>
                      <div className="form-group">
                        <label className="form-label">
                          <FaUser className="me-2" /> Full Name *
                        </label>
                        <Form.Control
                          type="text"
                          name="firstName"
                          placeholder="Enter your full name"
                          value={formData.firstName}
                          onChange={handleChange}
                          isInvalid={!!formErrors.firstName}
                          required
                          className="form-control-lg"
                        />
                        <Form.Control.Feedback type="invalid">
                          {formErrors.firstName}
                        </Form.Control.Feedback>
                      </div>
                    </Col>

                    <Col md={6}>
                      <div className="form-group">
                        <label className="form-label">
                          <FaPhone className="me-2" /> Mobile Number *
                        </label>
                        <Form.Control
                          type="tel"
                          name="mobileNumber"
                          placeholder="Enter 10-digit mobile number"
                          value={formData.mobileNumber}
                          onChange={handleChange}
                          isInvalid={!!formErrors.mobileNumber}
                          maxLength={10}
                          pattern="[0-9]*"
                          required
                          className="form-control-lg"
                        />
                        <Form.Control.Feedback type="invalid">
                          {formErrors.mobileNumber}
                        </Form.Control.Feedback>
                      </div>
                    </Col>

                    <Col md={6}>
                      <div className="form-group">
                        <label className="form-label">
                          <FaEnvelope className="me-2" /> Email Address
                        </label>
                        <Form.Control
                          type="email"
                          name="email"
                          placeholder="Enter your email"
                          value={formData.email}
                          onChange={handleChange}
                          isInvalid={!!formErrors.email}
                          className="form-control-lg"
                        />
                        <Form.Control.Feedback type="invalid">
                          {formErrors.email}
                        </Form.Control.Feedback>
                      </div>
                    </Col>

                    <Col md={6}>
                      <div className="form-group">
                        <label className="form-label">
                          <FaMapMarkerAlt className="me-2" /> Address *
                        </label>
                        <Form.Control
                          as="textarea"
                          name="address"
                          placeholder="Enter your complete address"
                          rows={3}
                          value={formData.address}
                          onChange={handleChange}
                          isInvalid={!!formErrors.address}
                          required
                          className="form-control-lg"
                        />
                        <Form.Control.Feedback type="invalid">
                          {formErrors.address}
                        </Form.Control.Feedback>
                      </div>
                    </Col>

                    <Col md={6}>
                      <div className="form-group">
                        <label className="form-label">
                          <FaCity className="me-2" /> City *
                        </label>
                        <Form.Control
                          type="text"
                          name="city"
                          placeholder="Enter your city"
                          value={formData.city}
                          onChange={handleChange}
                          isInvalid={!!formErrors.city}
                          required
                          className="form-control-lg"
                        />
                        <Form.Control.Feedback type="invalid">
                          {formErrors.city}
                        </Form.Control.Feedback>
                      </div>
                    </Col>

                    <Col md={6}>
                      <div className="form-group">
                        <label className="form-label">State *</label>
                        <Form.Select
                          value={stateType}
                          onChange={handleStateTypeChange}
                          className="form-control-lg"
                        >
                          <option value="">Select State</option>
                          <option value="tamilnadu">Tamil Nadu</option>
                          <option value="other">Other State</option>
                        </Form.Select>
                        {stateType === "other" && (
                          <Form.Control
                            type="text"
                            name="state"
                            placeholder="Enter your state name"
                            value={formData.state}
                            onChange={handleOtherStateChange}
                            isInvalid={!!formErrors.state}
                            required
                            className="form-control-lg mt-2"
                          />
                        )}
                        {stateType === "tamilnadu" && (
                          <Form.Control
                            type="text"
                            value="Tamil Nadu"
                            disabled
                            className="form-control-lg mt-2"
                            style={{ backgroundColor: '#f8f9fa' }}
                          />
                        )}
                        {formErrors.state && stateType === "other" && (
                          <div className="text-danger small mt-1">{formErrors.state}</div>
                        )}
                      </div>
                    </Col>

                    <Col md={6}>
                      <div className="form-group">
                        <label className="form-label">Pincode *</label>
                        <Form.Control
                          type="text"
                          name="pincode"
                          placeholder="Enter 6-digit pincode"
                          value={formData.pincode}
                          onChange={handleChange}
                          isInvalid={!!formErrors.pincode}
                          required
                          maxLength={6}
                          inputMode="numeric"
                          pattern="[0-9]{6}"
                          className="form-control-lg"
                        />
                        <Form.Control.Feedback type="invalid">
                          {formErrors.pincode}
                        </Form.Control.Feedback>
                      </div>
                    </Col>
                    <Col md={6}>
                      <div className="form-group">
                        <label className="form-label">Chit Code</label>
                        <Form.Control
                          type="text"
                          name="chitCode"
                          placeholder="Enter Chit Code"
                          value={formData.chitCode}
                          onChange={handleChange}
                          // isInvalid={!!formErrors.chitCode}
                          // required
                          // maxLength={6}
                          // inputMode="numeric"
                          // pattern="[0-9]{6}"
                          className="form-control-lg"
                        />
                        <Form.Control.Feedback type="invalid">
                          {formErrors.chitCode}
                        </Form.Control.Feedback>
                      </div>
                    </Col>
                  </Row>
                </Form>
              </Card.Body>
            </Card>
          </div>

          <div className="col-lg-4">
            <Card className="cart-summary-card shadow-sm">
              <Card.Body>
                <div className="summary-header mb-4">
                  <h4>Order Summary</h4>
                  <p className="text-muted">Review your order details</p>
                </div>

                {/* Order Summary */}
                <div className="order-summary mb-4">
                  <h6 className="summary-title">Price Details</h6>
                  <div className="summary-items">
                    <div className="summary-item d-flex justify-content-between">
                      <span>Subtotal</span>
                      <span className="fw-bold">
                        <i className="bi bi-currency-rupee"></i> {getSubtotal()}
                      </span>
                    </div>
                    <div className="summary-item d-flex justify-content-between">
                      <span>Discount ({Math.round(discountvalue)}%)</span>
                      <span className="text-success">
                        - <i className="bi bi-currency-rupee"></i> {getDiscountedTotal()}
                      </span>
                    </div>
                    <div className="summary-item d-flex justify-content-between border-bottom pb-2">
                      <span className="fw-bold">Total</span>
                      <span className="fw-bold">
                        <i className="bi bi-currency-rupee"></i> {orderTotal}
                      </span>
                    </div>

                    {/* Coupon Code Section */}
                    <div className="coupon-section mt-3">
                      <div className="input-group">
                        <Form.Control
                          type="text"
                          placeholder="Enter code"
                          value={couponCode}
                          onChange={handleCouponChange}
                          className="form-control"
                          disabled={isCouponApplied}
                        />
                        <Button
                          variant={isCouponApplied ? "success" : "primary"}
                          onClick={applyCoupon}
                          disabled={isCouponApplied || !couponCode}
                          className="btn-apply-coupon"
                        >
                          {isCouponApplied ? <FaCheck /> : 'Apply'}
                        </Button>
                      </div>
                      <p style={{color:"red",fontWeight:"bold",fontSize:"13px"}}>Enter Your Referal Number or Coupon Code</p>
                      {errorMessage && (
                        <div className="text-danger small mt-1">{errorMessage}</div>
                      )}
                      {isCouponApplied && coupondiscount > 0 && (
                        <div className="text-success small mt-1">
                          ✅ Coupon applied! {coupondiscount}% discount
                        </div>
                      )}
                    </div>

                    {isCouponApplied && coupondiscount > 0 && (
                      <div className="summary-item d-flex justify-content-between mt-2">
                        <span>Coupon Discount ({coupondiscount}%)</span>
                        <span className="text-success">
                          - <i className="bi bi-currency-rupee"></i> {coupondiscountamount()}
                        </span>
                      </div>
                    )}
                    {/* Packing Charge - Only show if percentage > 0 AND amount > 0 */}
                    {showPackingCharge && (
                      <div className="summary-item d-flex justify-content-between">
                        <span>Packing Charge ({packingPercent}%)</span>
                        <span className="text-info">
                          + <i className="bi bi-currency-rupee"></i> {packingAmount.toFixed(2)}
                        </span>
                      </div>
                    )}
                    <div className="summary-total d-flex justify-content-between mt-3 pt-3 border-top">
                      <span className="fw-bold">Grand Total</span>
                      <span className="fw-bold fs-5 text-primary">
                        <i className="bi bi-currency-rupee"></i> {grandTotalAmount}
                      </span>
                    </div>
                  </div>
                </div>

                {/* Payment Method Selection */}
                <div className="payment-section mb-3">
                  <h6 className="mb-3">Select Payment Method</h6>
                  <div className="payment-options d-flex gap-3">
                    <div
                      className={`payment-option ${paymentMethod === 'bank' ? 'active' : ''}`}
                      onClick={() => setPaymentMethod('bank')}
                      style={{
                        flex: 1,
                        padding: '12px',
                        border: `2px solid ${paymentMethod === 'bank' ? '#007bff' : '#ddd'}`,
                        borderRadius: '8px',
                        cursor: 'pointer',
                        textAlign: 'center',
                        backgroundColor: paymentMethod === 'bank' ? '#f0f7ff' : 'white',
                        transition: 'all 0.3s ease'
                      }}
                    >
                      <FaUniversity size={24} className={paymentMethod === 'bank' ? 'text-primary' : 'text-muted'} />
                      <div className="mt-1">
                        <small className={paymentMethod === 'bank' ? 'fw-bold text-primary' : 'text-muted'}>Bank Transfer</small>
                      </div>
                    </div>
                    <div
                      className={`payment-option ${paymentMethod === 'upi' ? 'active' : ''}`}
                      onClick={() => setPaymentMethod('upi')}
                      style={{
                        flex: 1,
                        padding: '12px',
                        border: `2px solid ${paymentMethod === 'upi' ? '#007bff' : '#ddd'}`,
                        borderRadius: '8px',
                        cursor: 'pointer',
                        textAlign: 'center',
                        backgroundColor: paymentMethod === 'upi' ? '#f0f7ff' : 'white',
                        transition: 'all 0.3s ease'
                      }}
                    >
                      <FaQrcode size={24} className={paymentMethod === 'upi' ? 'text-primary' : 'text-muted'} />
                      <div className="mt-1">
                        <small className={paymentMethod === 'upi' ? 'fw-bold text-primary' : 'text-muted'}>UPI Payment</small>
                      </div>
                    </div>
                  </div>

                  {/* Bank Details Display */}
                  {paymentMethod === 'bank' && bankDetails.account_name && (
                    <div className="bank-details mt-3 p-3 bg-light rounded">
                      <h6 className="mb-2">🏦 Bank Details:</h6>
                      <p style={{ margin: '5px 0' }}><strong>Account Name:</strong> {bankDetails.account_name}</p>
                      <p style={{ margin: '5px 0' }}><strong>Account Number:</strong> {bankDetails.account_no}</p>
                      <p style={{ margin: '5px 0' }}><strong>IFSC Code:</strong> {bankDetails.ifsc_code}</p>
                      <p style={{ margin: '5px 0' }}><strong>Branch Name:</strong> {bankDetails.branch_name}</p>
                      {bankDetails.bank_details && (
                        <p style={{ margin: '5px 0' }}><strong>Info:</strong> {bankDetails.bank_details}</p>
                      )}
                    </div>
                  )}
                </div>

                {/* Minimum Order Check */}
                {storeClosed === "1" ? (
                  <div className="alert alert-danger" role="alert">
                    <h6>Store Closed</h6>
                    <p className="mb-0">Our store is currently closed. Please try again later.</p>
                  </div>
                ) : (
                  <>
                    {minimumOrderMessage && (
                      <Link to="/shop" className="text-decoration-none">
    <div
      className={`alert ${
        stateSelected && isMinimumMet
          ? 'alert-success'
          : 'alert-warning'
      } mb-3`}
      role="alert"
      style={{ cursor: 'pointer' }}
    >
      <p className="mb-0">{minimumOrderMessage}</p>
    </div>
  </Link>
                    )}

                    <Button
                      variant="primary"
                      size="lg"
                      className="w-100 mb-3"
                      onClick={handleSubmit}
                      disabled={loading || cartItems.length === 0 || !stateSelected || !isMinimumMet}
                    >
                      {loading ? (
                        <>
                          <Spinner animation="border" size="sm" className="me-2" />
                          Processing...
                        </>
                      ) : (
                        <>
                          <FaWhatsapp className="me-2" />
                          {paymentMethod === 'bank' ? 'Place Order (Bank Transfer)' : 'Pay with UPI'}
                        </>
                      )}
                    </Button>
                  </>
                )}

                {/* Cart Info */}
                <div className="cart-info mt-4">
                  <div className="info-item d-flex align-items-center mb-2">
                    <div className="info-icon me-2">
                      <FaShoppingCart />
                    </div>
                    <div className="info-text">
                      <small className="text-muted">
                        {cartItems.length} item(s) in cart
                      </small>
                    </div>
                  </div>
                  <div className="info-item d-flex align-items-center">
                    <div className="info-icon me-2">
                      <FaTag />
                    </div>
                    <div className="info-text">
                      <small className="text-muted">
                        {Math.round(discountvalue)}% discount applied on eligible items
                      </small>
                    </div>
                  </div>
                </div>
              </Card.Body>
            </Card>
          </div>
        </div>
      </div>

      {/* Payment Modal */}
      <PaymentModal
        show={showPaymentModal}
        onClose={() => setShowPaymentModal(false)}
        onProceed={handlePaymentProceed}
        paymentMethod={paymentMethod}
        bankDetails={bankDetails}
        loading={loading}
        amount={grandTotalAmount}
        orderId={null}
        API_BASE_URL={API_BASE_URL}
      />

      <MobileNavigation />
      <Scroll />
    </div>
  );
}

export default Cart;